// extracted by mini-css-extract-plugin
export var infoItem = "_oa-2";
export var title = "_oa-0";
export var value = "_oa-1";